import { Component, HostListener, OnInit, Inject, PLATFORM_ID, OnDestroy, Renderer2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvService } from '../../services/env.service';
import { MainBodyService } from '../../services/main-body.service';
import { mediaLink, responsedata, themeData } from 'src/interface/themesetting';
import { catchError, debounceTime, EMPTY, filter, finalize, map, of, Subject, Subscription, switchMap } from 'rxjs';
import { GetArticlesService } from '../../services/get-articles.service';
import { listAllarticle, listArticle } from 'src/interface/article';
import { SharedService } from '../../services/shared.service';
import { EditorialService } from 'src/app/services/editorial.service';
import { editorsHomeList } from 'src/interface/editorial-board';
import { JournalService } from '../journal.service';
import { contentDataJBA, contentData1, contentGet } from 'src/interface/contentGet';
import { editorialListResponseData, editorsList } from 'src/interface/editorial-board';
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ViewEditorDetailsComponent } from '../../editorial-board/view-editor-details/view-editor-details.component';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { GetContentManagementDataService } from 'src/app/services/get-content-management-data.service';
import { PreloadImageService } from 'src/app/services/preload-image.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-journal-home',
    templateUrl: './journal-home.component.html',
    styleUrls: ['./journal-home.component.scss']
})
export class JournalHomeComponent implements OnInit, OnDestroy {
    searchedArticles: listArticle[] = [];
    defaultCoverImage: string;
    valueForSearch = '';
    queryParams: { length: number; start: number; search_key: string; search_filters: string; search_keywords: string; sort_by: string; };
    dataToBeDisplay = 3;
    startArticle = 0;
    private searchSubject = new Subject<string>();
    private searchTerm: string | null = null;
    private readonly minSearchLength = 3;
    searchSub: Subscription;
    tempSearchArticles: listArticle[] = [];
    uncheck: boolean[] = [false, false, false, false];
    search_filters: string[] = [];
    journalid: string;
    themeSettingsData: themeData;
    themePath: string;
    defaultJournalCoverImage: string;
    recentArticles: listArticle[] = [];
    fasttrackArticles: listArticle[] = [];
    featuredArticle: listArticle[] = [];
    mostViewedArticlesList: listArticle[] = [];
    mostDownloadedArticlesList: listArticle[] = [];
    image: string;
    themeimageUrl: string;
    defaultJournalLogo: string;
    searchLoader: boolean;
    show_search_list: boolean;
    recent = 'recent';
    fasttrack = 'fasttrack';
    featured = 'featured';
    most_viewed = 'most_viewed';
    most_downloaded = 'most_downloaded';
    subject_area_filter = false;
    selectDiv = false;
    editorsImageUrl: string;
    firstHalfeditorialDetails: editorsHomeList[] = []
    secondHalfEditorialDetails: editorsHomeList[] = [];
    i: number;
    faqArray: any[] = [];
    articleData: listArticle[] = [];
    articleCoverImageUrl: string;
    aims_id;

    loading = true;
    editorial_items = new Array(4).fill(0);
    items = new Array(15).fill(0);
    about_article = new Array(4).fill(0);
    about_article1 = new Array(2).fill(0);
    noimage_loader = true;
    dynamic_menus_journal: contentDataJBA[] = [];
    dynamic_menus: contentData1[] = [];
    volume_id = '';
    issue_id = '';
    searchListLoader: boolean;
    editorsDetails: editorialListResponseData[] = [];
    modalclose = '';
    metadata: any;
    subscriptionArr: Subscription[] = [];
    contentGet: contentGet = {
        journal_id: '',
        page_name_id: '',
        language_key: ''
    };
    newsContent: string;
    screenWidth: number;
    bannerImageUrl: string;
    default_article_cover_image_upto_11: string;
    default_article_cover_image_above_11: string;
    screenHeight: number;
    loadingForEditorialBoard = true;
    loadingForArticle = true;
    loaderForNews = true;
    backgroundStyle = {};
    schema = {};
    constructor(private route: ActivatedRoute, private mainBodyService: MainBodyService, public EnvService: EnvService,
        private articleService: GetArticlesService, private router: Router, private sharedService: SharedService,
        private editorialService: EditorialService, private journalService: JournalService, private modalservice: NgbModal,
        private titleService: Title, private metatag: Meta,
        @Inject(PLATFORM_ID) private platformId: any,
        private contentService: GetContentManagementDataService,
        private preloadImageService: PreloadImageService,
        @Inject(DOCUMENT) private document: Document,
        public renderer: Renderer2,

    ) {

        this.themeSettingsData = {
            journal_id: '',
            journal_logo: '',
            logo_alt_text: '',
            journal_banner: '',
            journal_display_name: '',
            banner_type: '',
            banner_heading: '',
            banner_content: '',
            banner_secondary_content: '',
            button_label: '',
            button_link: '',
            contact_us: {
                address_line_1: '',
                address_line_2: '',
                address_line_3: '',
                phone_number: 9123456789,
                email: ''
            },
            journal_about: '',
            social_media_links: [{
                label: 'Facebook link',
                key: 'facebook_link',
                icon: ['fab', 'facebook'],
                value: '',
            }],
            theme_colors: {
                button_color: '',
                button_text_color: '',
                primary_color: '',
                primary_footer_background_color: '',
                primary_footer_text_color: '',
                primary_header_background_color: '',
                primary_header_text_color: '',
                secondary_color: '',
                secondary_footer_background_color: '',
                secondary_footer_text_color: '',
                secondary_header_background_color: '',
                secondary_header_text_color: '',
                text_primary_color: '',
                text_secondary_color: ''
            },
            fullwidthcheck: '',
            transimagecheck: '',
            banner_transparent_image: '',
            banner_fullwidth_image: '',
            banner_full_alt_text: '',
            banner_trans_alt_text: '',
            about: '',
            journal_title: ''
        }
        const journalsub = this.route.params.subscribe(params => {
            this.journalid = params['journal_id'];
            this.sharedService.setJournalId(this.journalid);
            this.sharedService.setUrlParams(params);
        });
        this.subscriptionArr.push(journalsub);
        this.themePath = EnvService.imageUrl + 'themes/';
        if (isPlatformBrowser(this.platformId)) {
            this.screenWidth = window.innerWidth;
        }
        this.updateBannerImageUrl();
    }

    ngOnInit(): void {
        // this.setBackgroundImage();
        // this.bannerImageUrl = this.EnvService.bannerImage;
        this.default_article_cover_image_upto_11 = this.EnvService.default_article_cover_image_upto_11;
        this.default_article_cover_image_above_11 = this.EnvService.default_article_cover_image_above_11;
        this.titleService.setTitle('Home | The Journal of British Academy ')
        this.metatag.updateTag({ property: 'og:url', content: this.EnvService.siteUrl });
        // Note: this component is only ever routed without a :journal_id param (home '' route
        // and the content/:page_name_id group), so this.journalid is always undefined at this
        // point and the "if (this.journalid == undefined)" block below always runs. An extra
        // getJournals() call used to fire here first and its result was immediately discarded -
        // that was a pure duplicate network round trip on every page load, removed.
        this.defaultJournalCoverImage = this.EnvService.defaultImagePath + this.EnvService.default_journalCoverImage;
        this.defaultCoverImage =
            this.EnvService.defaultImagePath +
            this.EnvService.default_articleCoverImage;
        this.themeimageUrl = this.EnvService.imageUrl + 'themes/';
        this.editorsImageUrl = this.EnvService.editorialImage;
        this.defaultJournalLogo = this.EnvService.defaultImagePath + this.EnvService.default_journalLogo;
        const getjournalsubs = this.sharedService.getJournalId().subscribe(journalId => {
            this.journalid = journalId;
        });
        this.subscriptionArr.push(getjournalsubs);
        if (this.journalid == undefined) {
            const journalType = { jnl_type: "JNL" }
            // This single call is the entry point for the whole page's dynamic content (theme,
            // editorial board, articles, news all get kicked off from inside its callback below).
            // It previously had no error handling at all, so an HTTP failure here - or a 200
            // response with an empty `data` array, which looks fine in the network tab but made
            // `result.data[0].id` below throw synchronously and silently abort the rest of this
            // callback - left every section's skeleton/spinner on screen forever with nothing in
            // the console or network tab pointing at why. Both cases are now guarded so the
            // skeletons always clear instead of hanging indefinitely.
            const getjournalsubs = this.journalService.getJournals(journalType).pipe(
                catchError(() => {
                    this.clearHomeLoadingFlags();
                    return EMPTY;
                })
            ).subscribe((result) => {
                if (!result?.data?.length) {
                    this.clearHomeLoadingFlags();
                    return;
                }
                this.journalid = result.data[0].id;
                this.titleService.setTitle('Home | ' + result.data[0].journal_display_name)

                this.metatag.updateTag(
                    { property: 'og:type', content: result.data[0].journal_type.type },
                );
                this.metatag.updateTag(
                    { property: 'og:title', content: result.data[0].journal_display_name },
                );
                this.metatag.updateTag(
                    { property: 'og:image', content: this.themeimageUrl + result.data[0].journal_cover_image },
                );
                this.schema = {
                    '@context': 'http://schema.org',
                    '@type': 'Organization',
                    "name": result.data[0].journal_display_name,
                    // "datePublished": new Date(this.published_date).toISOString(),
                    'url': this.EnvService.siteUrl,
                    'logo': this.EnvService.siteUrl + 'assets/logos/jba_logo.webp',

                }
                if (isPlatformBrowser(this.platformId)) {
                    this.injectJsonLd(this.schema);
                }
                //  this. getDynamicMenusJournal(this.journalid) ;
                this.articleCoverImageUrl =
                    this.EnvService.articleCoverImage + this.journalid + '/';
                this.mainBodyService.urlchange(true);
                // Every input change (typing, backspace, clearing) goes through here. Short/empty
                // terms still pass through switchMap so any in-flight request is cancelled, and each
                // response carries the term it was requested for, so stale results are dropped.
                this.searchSub = this.searchSubject.pipe(
                    debounceTime(500),
                    switchMap((term: string) => term.length < this.minSearchLength
                        ? of({ term, result: null, skipped: true })
                        : this.articleService.searchArticle(this.buildSuggestionParams(term), this.journalid).pipe(
                            map(result => ({ term, result, skipped: false })),
                            catchError(() => of({ term, result: null, skipped: false }))
                        )
                    )
                ).subscribe(({ term, result, skipped }) => {
                    if (skipped || term !== this.searchTerm) {
                        return;
                    }
                    this.searchLoader = false;
                    if (!result) {
                        // Request failed: don't claim there are no matching articles.
                        this.show_search_list = false;
                        return;
                    }
                    this.searchedArticles = result.data ?? [];
                    this.tempSearchArticles = this.searchedArticles;
                    this.show_search_list = true;
                })
                if (this.journalid) {
                    this.contentGet = {
                        journal_id: this.journalid,
                        page_name_id: 'news',
                        language_key: 'en-gb'
                    };
                    // finalize() so a request error still clears the news skeleton instead of
                    // leaving it stuck (same class of bug as the calls above).
                    this.contentService.getCurrentContentData(this.contentGet).pipe(
                        finalize(() => { this.loaderForNews = false; })
                    ).subscribe({
                        next: (result: any) => {
                            if (result.data[0]) {
                                this.newsContent = result.data[0].page.page_content['en-GB'];
                            }
                            else {
                                this.newsContent = '';
                            }
                        },
                        error: () => { /* loaderForNews already cleared via finalize() above */ }
                    });
                    // Fetched on both server and browser (was browser-only before) so the theme
                    // banner/colors and editorial board are present in the server-rendered HTML
                    // instead of only appearing after a client-side re-fetch post-hydration.
                    // DOM writes below stay behind isPlatformBrowser since there's no DOM on the server.
                    // `loading` gates the About/search section (see journal-home.component.html,
                    // *ngIf="loading" vs *ngIf="!loading") and used to only clear inside the
                    // `result.status == 200` branch. The backend returns plain HTTP 200 with a
                    // body status of 201/204 when it has nothing for this journal_id (see
                    // ThemeManage::getlogoandbanner), and any HTTP-level error was unhandled - in
                    // both cases `loading` was never reset, so the section stayed on its skeleton
                    // placeholder indefinitely even though the request itself had already
                    // completed. finalize() guarantees it clears no matter how the call resolves.
                    const getallthemesubs = this.mainBodyService.getAllThemeSettings(this.journalid).pipe(
                        finalize(() => { this.loading = false; })
                    ).subscribe({
                        next: (result: responsedata) => {
                            if (result.status == 200) {
                                this.themeSettingsData = result.data;
                                Object.entries(this.themeSettingsData.theme_colors).map(([key, value]) => {
                                    const element = "--" + key;
                                    const val = value;
                                    if (isPlatformBrowser(this.platformId)) {
                                        document.documentElement.style.setProperty(element, val);
                                    }
                                });
                            }
                            const firstThreeLines = this.themeSettingsData.journal_about
                                .replace(/<[^>]*>/g, '') // Remove HTML tags
                                .split(/[.!?]/) // Split into sentences
                                .filter(sentence => sentence.trim() !== '') // Remove empty sentences
                                .slice(0, 3) // Take the first three sentences
                                .join('\n'); // Join with newline
                            this.metatag.updateTag(
                                { property: 'og:description', content: firstThreeLines },
                            );
                        },
                        error: () => { /* loading already cleared via finalize() above */ }
                    });
                    this.subscriptionArr.push(getallthemesubs);
                    // const journalId={'journal_id':this.journalid}
                    const journalId = { 'journal_id': this.journalid }
                    // finalize() so a request error still clears the skeleton below instead of
                    // leaving it stuck (same class of bug as the theme settings call above).
                    const geteditorialsubs = this.editorialService.getEditorialMembers(journalId).pipe(
                        finalize(() => { this.loadingForEditorialBoard = false; })
                    ).subscribe({
                        next: (response) => {
                        this.firstHalfeditorialDetails = response.data;
                        // if (response.data.length == 8) {
                        //     const midpoint = Math.ceil(response.data.length / 2);
                        //     this.firstHalfeditorialDetails = response.data.slice(0, midpoint);
                        //     this.secondHalfEditorialDetails = response.data.slice(midpoint);
                        // }
                        // else {
                        //     if (response.data.length >= 4) {
                        //         // Slice the first four elements
                        //         this.firstHalfeditorialDetails = response.data.slice(0, 4);

                        //         // Slice the remaining elements, if any
                        //         this.secondHalfEditorialDetails = response.data.slice(4);
                        //     } else {
                        //         // If the array has less than four elements, assign the entire array to the first part
                        //         this.firstHalfeditorialDetails = response.data;
                        //         this.secondHalfEditorialDetails = [];
                        //     }
                        // }


                        },
                        error: () => { /* loadingForEditorialBoard already cleared via finalize() above */ }
                    })
                    this.subscriptionArr.push(geteditorialsubs);
                }
                const journalId = { journal_id: this.journalid }
                const checkjournalsubs = this.articleService.checkJournal(journalId).subscribe(result => {
                    // this.articleService.checkJournal(journalId).subscribe(result => {


                    // if(result.status == 204){
                    //  this.router.navigate(['/not-found/404'])  
                    // }
                });
                this.subscriptionArr.push(checkjournalsubs);
                // });

                const getfaqsubs = this.articleService.getFaqData(journalId).subscribe(result => {
                    this.faqArray = result.data;

                });
                this.subscriptionArr.push(getfaqsubs);
                this.getArticlesList();
            })
            this.subscriptionArr.push(getjournalsubs);



        }
        setTimeout(() => {
            this.metatag.addTag({ property: 'og:url', content: this.EnvService.siteUrl });
            this.metatag.addTag({ property: 'og:title', content: this.themeSettingsData.journal_title });
            this.metatag.addTag({ property: 'og:description', content: this.themeSettingsData.banner_content });
        }, 1000)
        this.updateScreenDimensions();
        this.updateBannerImageUrl();



    }
    // Clears every section loader shown on this page. Used when the entry-point getJournals()
    // call fails or comes back with nothing, so none of the downstream fetches that normally
    // flip these flags ever get a chance to run - without this they'd stay on their skeleton
    // placeholders indefinitely.
    private clearHomeLoadingFlags(): void {
        this.loading = false;
        this.loadingForEditorialBoard = false;
        this.loadingForArticle = false;
        this.loaderForNews = false;
    }
    injectJsonLd(schema: any): void {
        if (isPlatformBrowser(this.platformId)) {
            const existingScripts = this.document.head.querySelectorAll('script[type="application/ld+json"]');

            existingScripts.forEach(script => {
                script.parentNode?.removeChild(script);
            });

            const script = this.renderer.createElement('script');
            script.type = 'application/ld+json';
            script.text = JSON.stringify(schema);
            this.renderer.appendChild(this.document.head, script);
        }
    }

    ngOnDestroy(): void {
        this.destroyMetaTagsforSEONew()
    }
    updateMetaTags(themeSettingsData: themeData) {

        // this.meta.updateOgUrl(this.EnvService.siteUrl)
        // this.meta.updateTitle(themeSettingsData.journal_title)
        // this.meta.updateDescription(themeSettingsData.banner_content)
        // this.meta.setPropertyTags([{ property: 'og:description', content: themeSettingsData.banner_content }])
        // this.metatag.updateTag(
        //     { property: 'og:url', content: this.EnvService.siteUrl },
        // );
        // this.metatag.updateTag(
        //     { property: 'og:title', content: themeSettingsData.journal_title },
        // );
        // this.metatag.updateTag(
        //     { property: 'og:description', content: themeSettingsData.banner_content },
        // );
    }


    showSearchedArticle(isClicked: boolean) {
        this.cancelSuggestions();
        this.searchLoader = !isClicked;
        if (isClicked) {
            let url = '/articles';
            const queryParams = {};
            if (this.valueForSearch) {
                queryParams['search'] = this.valueForSearch;
            }
            if (this.search_filters.length > 0) {
                queryParams['filters'] = this.search_filters.toString();
            }
            if (this.volume_id != '' && this.issue_id != '') {
                url = url + '/' + this.volume_id + '/' + this.issue_id;
            }
            url = url + '/page/1';
            this.router.navigate([url], { queryParams });
        }
    }

    checkBoxChange(event: string[]) {
        this.search_filters = event;
    }

    @HostListener('document:keydown.enter', ['$event']) onKeydownHandler() { //event: KeyboardEvent
        this.showSearchedArticle(true);
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside() { //event: MouseEvent
        this.show_search_list = false;
    }


    getHomeImage(themeSettingsData: themeData) {
        let image = 'none';
        if (themeSettingsData.banner_type == 'Fullwidth') {
            image = this.themeimageUrl + themeSettingsData.banner_fullwidth_image;
        }
        if (themeSettingsData.banner_transparent_image == null && themeSettingsData.banner_fullwidth_image == null && themeSettingsData.banner_type == null) {
            image = this.defaultJournalCoverImage;
        }
        return image;

    }

    clearSearch(isClick: boolean) {
        if (isClick) {
            this.searchedArticles = [];
        }
        this.cancelSuggestions();
        this.valueForSearch = '';
        const queryParams: listAllarticle = {
            length: this.dataToBeDisplay,
            start: 0,
            search_key: '',
            search_filters: '',
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            special_issue: false,
            thematic_id: ''
            // favourites_data:[],
            // journal_id:''
        }
        const getarticlesub = this.articleService.getArticles(queryParams, this.journalid).subscribe(result => {
            this.recentArticles = result.data;
        })
        this.subscriptionArr.push(getarticlesub);
    }

    returnSocialMedia(journalSettingData: themeData) {
        let links: mediaLink[] = [];
        if (journalSettingData?.social_media_links) {
            links = journalSettingData.social_media_links;
        }
        return links;
    }

    searchEmitFunction(searchData: string) {
        this.valueForSearch = searchData ?? '';
        const term = this.valueForSearch.trim();
        // Keys that don't change the value (arrows, shift, ...) must not reset the suggestions.
        if (term === this.searchTerm) {
            return;
        }
        this.searchTerm = term;
        // Drop results of the previous term; "No article found" is only shown once the API
        // has answered for this exact term.
        this.searchedArticles = [];
        this.show_search_list = false;
        this.searchLoader = term.length >= this.minSearchLength;
        this.searchSubject.next(term);
    }

    buildSuggestionParams(term: string) {
        return {
            length: this.dataToBeDisplay,
            start: 0,
            search_key: term,
            search_filters: '',
            search_keywords: '',
            sort_by: ''
        };
    }

    // Hides the suggestion dropdown and makes any pending/in-flight response be ignored.
    cancelSuggestions() {
        this.searchTerm = null;
        this.searchLoader = false;
        this.show_search_list = false;
    }
    // chunkArray(array: editorsHomeList[], chunkSize: number): editorsHomeList[][] {
    //     const chunks: editorsHomeList[][] = [];
    //     for (let i = 0; i < array.length; i += chunkSize) {
    //         if (i == 7) {
    //             break;
    //         }
    //         else chunks.push(array.slice(i, i + chunkSize));
    //     }
    //     return chunks;
    // }
    // getAllEditorialMember() {
    //     const journalId = { 'journal_id': this.journalid, 'page': 'listing-page' }
    //     this.editorialService.getEditorialMembers(journalId).subscribe((response) => {
    //         //    this.editorsDetails.push(response)

    //     })
    // }
    getArticlesList() {
        this.articleData = [];
        const queryParams = {
            length: 5,
            start: 0,
            search_key: '',
            search_filters: 'featured',
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            journal_id: this.journalid
        };

        // finalize() so a request error still clears the skeleton instead of leaving the
        // featured-article hero section stuck (same class of bug as the calls above).
        const getarticlesubs = this.articleService
            .getArticles(queryParams, this.journalid)
            .pipe(finalize(() => { this.loadingForArticle = false; }))
            .subscribe({
                next: (result) => {
                    if (result.data.length !== 0) this.articleData = result.data;
                },
                error: () => { /* loadingForArticle already cleared via finalize() above */ }
            });
        this.subscriptionArr.push(getarticlesubs);
    }
    getAuthorsString(authors: any[]): string {

        if (authors.length === 0) return '';

        const authorNames = authors.map(author =>
            `${author.specific_use === "icwau" ? "in conversation with " : `${author.specific_use === "wffau" ? "with a Foreword from " : ""}`}${author.first_name} ${author.last_name}`
        );
        return authorNames.join(', ');
    }
    removeCommaFromDate(dateString: string): string {
        return dateString.replace(',', '');
    }
    getArticleImageUrl(oneArticle) {
        let url = '';
        url =
            oneArticle.volume +
            '/' +
            oneArticle.issue +
            '/' +
            oneArticle.article_id +
            '/' +
            oneArticle.article_cover_image;
        return url;
    }

    openOrcidLink(orcid: string) {
        if (isPlatformBrowser(this.platformId)) {
            window.open('https://orcid.org/' + orcid, 'Orcid Link', 'resizeable,height=800,width=600');
        }
    }

    ensureHttps(url: string) {
        if (url != undefined) {
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                return 'https://doi.org/' + url;
            }
            return url;
        }
        return url;
    }
    getDynamicMenusJournal(journalid) {

        // this.loadThemeSettings();
        const dynamicMenuSub = this.mainBodyService
            .getAllDynamicMenus(journalid)
            .subscribe((result) => {

                // this.processMenuData(result);
                this.dynamic_menus_journal = [];
                this.dynamic_menus = [];

                this.aims_id = result.data[0].journal_pages.find(page => page.page_heading['en-GB'] == 'Aims and Scope');

                this.router.navigate(['/content/' + this.aims_id.page_identifier]);


            });
        this.subscriptionArr.push(dynamicMenuSub);

    }
    emitedVolume(volume: string) {
        this.volume_id = volume;
    }
    emitedIssue(issue: string) {
        this.issue_id = issue;
    }
    searchListLoadeEventReader(event: boolean) {
        this.searchListLoader = event;
    }
    getDetails(editorDetails: editorsList) {
        const modal: NgbModalRef = this.modalservice.open(ViewEditorDetailsComponent, { ariaLabelledBy: 'modal-content', size: 'xl' })
        modal.result.then((res) => {
            this.modalclose = `Closed with: ${res}`;
        }, (res) => {
            this.modalclose = `Dismissed ${this.getDismissReason(res)}`;
        });
        modal.componentInstance.details = editorDetails;
    }
    private getDismissReason(reason): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    public destroyMetaTagsforSEONew() {
        this.metatag.updateTag(
            { property: 'og:url', content: this.EnvService.siteUrl },
        );
        this.metatag.updateTag(
            { property: 'og:title', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'og:description', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'og:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        );
        this.metatag.updateTag(
            { property: 'twitter:title', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'twitter:description', content: "Journal of the British Academy" },
        );
        this.metatag.updateTag(
            { property: 'twitter:image', content: this.EnvService.imageUrl + "themes/default_logo.png" },
        );
    }
    checkProfesor(data: string) {
        return data.includes('Professor') ? 'PROFESSOR' : '';

    }
    checkName(data: string) {
        return data.replace('Professor', '').trim().toUpperCase();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.updateScreenDimensions();
        this.updateBannerImageUrl();
    }

    updateScreenDimensions() {
        if (isPlatformBrowser(this.platformId)) {
            this.screenWidth = window.innerWidth - 12;
            this.screenHeight = window.innerHeight - 11;

        }
    }

    updateBannerImageUrl() {
        if (this.screenWidth <= 485) {
            this.bannerImageUrl = '/485x550.webp';
        }
        else if (this.screenWidth <= 576) {
            this.bannerImageUrl = '/576x550.webp';
        }
        else if (this.screenWidth <= 767) {
            if (this.screenHeight <= 604) {
                this.bannerImageUrl = '/767x604.webp';
            }
            else {
                this.bannerImageUrl = '/767x1100.webp';
            }

        }
        else if (this.screenWidth <= 992) {
            if (this.screenHeight <= 604) {
                this.bannerImageUrl = '/992x604.webp';
            }
            else {
                this.bannerImageUrl = '/992x1100.webp';
            }

        }
        else if (this.screenWidth <= 1200) {

            this.bannerImageUrl = '/1200x1100.webp';

        }

        else if (this.screenWidth <= 1400) {

            this.bannerImageUrl = '/1400x1100.webp';

        }
        else {
            this.bannerImageUrl = '/1400x1100.webp';
        }
        this.preloadImageService.setPreloadLink('assets/images/banners' + this.bannerImageUrl);
        this.backgroundStyle = {
            'background-image': `url('assets/images/banners${this.bannerImageUrl}')`,
            'background-size': 'cover'
        };
    }

    // Footnote xrefs in a title (e.g. <xref ref-type="fn" rid="fn1"><sup>1</sup></xref>)
    // are excluded entirely here, digit included, since this listing has no footnote
    // section/tooltip for the marker to refer to.
    private stripFootnoteXref(title: string): string {
        if (!title) {
            return title;
        }
        return title.replace(/<xref[^>]*ref-type=["']fn["'][^>]*>[\s\S]*?<\/xref>/gi, '');
    }

    getCleanTitle(title: string): string {
        return this.stripFootnoteXref(title).replace(/<[^>]*>/g, '');
    }

    // Preserves non-footnote superscript markers (e.g. <sup>2+</sup>) in article titles
    // while stripping every other tag, so numbers don't get appended as plain text.
    getFormattedTitle(title: string): string {
        if (!title) {
            return title;
        }
        return this.stripFootnoteXref(title)
            .replace(/<(?!\/?sup\b)[^>]*>/gi, '');
    }

}